// Les SVG exacts issus de ton PHP
const ICON_FULL = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.18 15.18" width="18" height="18"><path d="M8.59,15.18c-.2,0-.39-.08-.53-.22L1.43,8.33c-.92-.92-1.43-2.15-1.43-3.45S.51,2.35,1.43,1.43,3.57,0,4.88,0s2.53.51,3.45,1.43l.27.27.27-.27c.45-.46.99-.81,1.58-1.06,1.19-.49,2.54-.49,3.73,0,.59.24,1.12.6,1.58,1.06c.92.92,1.43,2.15,1.43,3.45s-.51,2.53-1.43,3.45l-6.63,6.63c-.14.14-.33.22-.53.22Z"/></svg>`;

const ICON_EMPTY = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.18 15.18" width="18" height="18"><path d="M8.59,15.18c-.2,0-.39-.08-.53-.22L1.43,8.33c-.92-.92-1.43-2.15-1.43-3.45S.51,2.35,1.43,1.43,3.57,0,4.88,0s2.53.51,3.45,1.43l.27.27.27-.27c.45-.46.99-.81,1.58-1.06,1.19-.49,2.54-.49,3.73,0,.59.24,1.12.6,1.58,1.06h0c.46.46.81.99,1.06,1.58.25.6.37,1.22.37,1.87s-.12,1.27-.37,1.87c-.25.59-.6,1.13-1.06,1.58l-6.63,6.63c-.14.14-.33.22-.53.22ZM4.88,1.5c-.9,0-1.75.35-2.39.99s-.99,1.49-.99,2.39.35,1.75.99,2.39l6.1,6.1,6.1-6.1c.32-.32.56-.68.73-1.09.17-.41.26-.85.26-1.29s-.09-.88-.26-1.29c-.17-.41-.42-.78-.73-1.1-.32-.32-.69-.56-1.09-.73-.83-.34-1.76-.34-2.59,0-.41.17-.78.42-1.09.73l-.79.8c-.29.29-.77.29-1.06,0l-.8-.8c-.64-.64-1.49-.99-2.39-.99Z"/></svg>`;

export default class WishAjax {
    constructor() {
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

        this.init();
        this.loadWishlist();
    }

    init() {
        const checkboxes = document.querySelectorAll('.wish-checkbox input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.removeEventListener('change', this.handleCheckboxChange);
            checkbox.addEventListener('change', this.handleCheckboxChange);
        });
    }

    loadWishlist() {
        let likedPosts = JSON.parse(localStorage.getItem('liked_posts')) || [];
        likedPosts = likedPosts.map(String);
        let hasChanges = false;

        const checkboxes = document.querySelectorAll('.wish-checkbox input[type="checkbox"]');

        checkboxes.forEach(checkbox => {
            const postId = String(checkbox.getAttribute('data-post-id'));

            if (checkbox.defaultChecked && !likedPosts.includes(postId)) {
                likedPosts.push(postId);
                hasChanges = true;
            }

            if (likedPosts.includes(postId)) {
                checkbox.checked = true;
            } else {
                checkbox.checked = false;
            }
        });

        if (hasChanges) {
            localStorage.setItem('liked_posts', JSON.stringify(likedPosts));
            if(this.updateNavbar) this.updateNavbar(likedPosts.length);
        }
    }

    async handleCheckboxChange(event) {
        const checkbox = event.target;
        const postId = String(checkbox.getAttribute('data-post-id'));
        const isChecked = checkbox.checked;

        let likedPosts = JSON.parse(localStorage.getItem('liked_posts')) || [];
        likedPosts = likedPosts.map(String);

        if (isChecked) {
            if (!likedPosts.includes(postId)) likedPosts.push(postId);
        } else {
            likedPosts = likedPosts.filter(id => id !== postId);
        }

        localStorage.setItem('liked_posts', JSON.stringify(likedPosts));

        try {
            const response = await fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'handle_wish',
                    post_id: postId,
                    liked: isChecked ? 1 : 0,
                })
            });

            if (!response.ok) throw new Error('Erreur serveur');

            if (document.querySelector('.my-account-wishlist')) {
                const itemRow = checkbox.closest('.wishlist-item');
                if (itemRow) {
                    itemRow.style.opacity = isChecked ? '1' : '0.5';
                }
            }

        } catch (error) {
            console.error('Erreur Ajax:', error);
            checkbox.checked = !isChecked;
        }
    }
}